// CANONICAL COPY (GH #7115). src/constants/obligations/obl-project-security.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-project-security',
  title: 'Verify information security is integrated into project management',
  description:
    "Confirm that information security is embedded in the organisation's project management methodology throughout the project lifecycle — regardless of project type. Security requirements, risk assessment, privacy by design, supplier-security obligations and change-management integration shall be explicit at project initiation and reassessed at defined milestones. Review the project management standard and project records to confirm security deliverables were produced and approved.",
  category: 'governance',
  scfIds: ['SCF-GOV-008'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Project management security standard is published',
    },
    { type: 'document-within-sla', description: 'Standard review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
